import { BaseError } from "./BaseError.ts";

export class ForbiddenError extends BaseError {
  public override readonly name = "ForbiddenError";
}
